import { KNOWLEDGE_LESSONS } from './types';

interface NotebookProps {
  unlockedIds: number[];
  onClose: () => void;
}

export default function Notebook({ unlockedIds, onClose }: NotebookProps) {
  const unlocked = KNOWLEDGE_LESSONS.filter(l => unlockedIds.includes(l.id));
  const locked = KNOWLEDGE_LESSONS.filter(l => !unlockedIds.includes(l.id));

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl max-w-lg w-full max-h-[85vh] flex flex-col overflow-hidden">
        <div className="bg-gradient-to-r from-amber-500 to-orange-400 p-5 flex items-center justify-between text-white flex-shrink-0">
          <div>
            <h3 className="font-extrabold text-lg">📓 Sổ tay An toàn Thực phẩm</h3>
            <p className="text-xs opacity-80 mt-0.5">Đã mở khóa {unlocked.length}/{KNOWLEDGE_LESSONS.length} bài học</p>
          </div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-full cursor-pointer hover:bg-white/30 transition-all">
            <i className="ri-close-line text-white"></i>
          </button>
        </div>

        {/* Safety rules quick reference */}
        <div className="bg-orange-50 border-b border-orange-100 px-4 py-3">
          <p className="text-xs font-extrabold text-orange-700 mb-2">⚠️ Quy trình nấu cơm lam an toàn:</p>
          <div className="grid grid-cols-2 gap-1.5">
            {[
              { emoji: '🍳', text: '1. Chọn đúng dụng cụ' },
              { emoji: '🙌', text: '2. Rửa tay 6 bước' },
              { emoji: '🎋', text: '3. Rửa dụng cụ sạch' },
              { emoji: '🌾', text: '4. Vo gạo cho trong' },
              { emoji: '🎍', text: '5. Chuẩn bị ống nứa' },
              { emoji: '🔥', text: '6. Người lớn nhóm lửa' },
              { emoji: '🌡️', text: '7. Giữ lửa vừa đủ' },
              { emoji: '🔄', text: '8. Xoay ống đều đặn' },
              { emoji: '✅', text: '9. Ăn chín uống sôi' },
              { emoji: '🚫', text: 'Không ăn đồ sống/cháy' },
            ].map((rule, i) => (
              <div key={i} className="flex items-center gap-1.5 text-xs text-orange-700 font-semibold">
                <span>{rule.emoji}</span><span>{rule.text}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="overflow-y-auto flex-1 p-4 space-y-3">
          {unlocked.length === 0 && (
            <div className="text-center py-8">
              <div className="text-5xl mb-3">📖</div>
              <p className="text-amber-600 text-sm">Hoàn thành các vòng để mở khóa bài học nhé!</p>
            </div>
          )}
          {unlocked.map(lesson => (
            <div key={lesson.id} className="bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 rounded-2xl p-4">
              <div className="flex items-start gap-3">
                <span className="text-2xl flex-shrink-0">{lesson.emoji}</span>
                <div>
                  <h4 className="font-bold text-amber-900 text-sm mb-1">{lesson.title}</h4>
                  <p className="text-xs text-amber-700 leading-relaxed">{lesson.content}</p>
                  <div className="mt-2 flex items-center gap-1.5">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-lightbulb-fill text-amber-500 text-xs"></i>
                    </div>
                    <p className="text-xs font-semibold text-amber-700">{lesson.tip}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
          {locked.length > 0 && (
            <div className="mt-2">
              <p className="text-xs text-gray-400 mb-2 font-semibold uppercase tracking-wide">Chưa mở khóa</p>
              {locked.map(lesson => (
                <div key={lesson.id} className="flex items-center gap-3 p-3 bg-gray-50 border border-gray-100 rounded-xl mb-2 opacity-60">
                  <div className="w-8 h-8 flex items-center justify-center bg-gray-200 rounded-full flex-shrink-0">
                    <i className="ri-lock-line text-gray-400 text-sm"></i>
                  </div>
                  <p className="text-sm text-gray-400 font-medium">{lesson.title}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
